// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/weui/dist/style/weui.min.css
// module id = 618
// module chunks = 0